<template>
  <div class="edit-modal" v-if="showModal">
    <div class="modalHeader">
      <span class="title">Create / Edit</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <center><h2 v-if="Object.keys(dataWidget).length">Matched Models</h2>
    <div v-for="(field, key) in matchedModels" :key="key">
      <p class="mb-1">{{ field.model }}</p>
    </div></center>

    <div class="modalBody">
      <div class="form-group">
        <div class="widget-input" v-for="(field, fieldKey) in fields" :key="fieldKey">
          <span class="widget-label">{{ field.title }}</span>
          <combo-widget v-if="field.type === 'combobox'"
            :fieldIndex="fieldKey.toString()"
            :initialValue="field.newValue.length ? field.newValue : field.originalValue"
            :key="fieldKey"
            :editable="field.editable"
            :fieldName="field.fieldName"
            :options="field.values">
            </combo-widget>
          <text-widget v-else-if="field.type === 'text'"
            :fieldIndex="fieldKey.toString()"
            :initialValue="field.newValue.length ? field.newValue : field.originalValue"
            :key="fieldKey"
            :fieldName="field.fieldName"
            :editable="field.editable">
            </text-widget>
          <checkbox-widget v-else-if="field.type === 'checkbox'"
            :fieldIndex="fieldKey.toString()"
            :initialValue="field.newValue.length ? field.newValue : field.originalValue"
            :key="fieldKey"
            :fieldName="field.fieldName"
            :editable="field.editable">
            </checkbox-widget>
          <div class="input-subtext">{{ field.desc }}</div>
        </div>
        <div>
          <input placeholder="Message from Widget" v-model="msgWidget" type="text" class="form-control form-control-sm" id="msgForWidget"/>
        </div>
      </div>
      <div class="button-box float-right">
        <button class="btn btn-success" @click="saveEdit">Save</button>
        <button class="btn btn-danger" @click="closeModal">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import ComboWidget from '@/components/questionnaires/widgets/ComboWidget'
import TextWidget from '@/components/questionnaires/widgets/TextWidget'
import CheckboxWidget from '@/components/questionnaires/widgets/CheckboxWidget'

export default {
  name: 'group-edit-modal',

  components: {
    ComboWidget,
    TextWidget,
    CheckboxWidget
  },

  mounted () {
    let that = this
    this.$on('showModal', function (data) {
      that.index = data.index
      that.fields = data.fields
      that.showModal = true
      that.msgWidget = data.msg
      that.dataWidget = data.data
      that.getMatchedModels()
    })

    this.$on('widgetChanged', function (data) {
      this.fields[data.index]['newValue'] = data.value
    })
  },

  data () {
    return {
      showModal: false,
      index: null,
      fields: {},
      msgWidget: '',
      dataWidget: {},
      matchedModels: {}
    }
  },

  methods: {
    getMatchedModels () {
      let fields = this.$store.getters.getMatchedWidgetFields(this.dataWidget.widget_id)
      this.matchedModels = fields
    },

    closeModal () {
      this.showModal = false
    },

    saveEdit () {
      this.$store.commit('saveMsgWidget', {
        msg: this.msgWidget,
        model: this.dataWidget.model
      })

      this.$bus.emit('msgWidget', {
        message: this.msgWidget,
        model: this.dataWidget.model
      })
      this.$bus.emit('updateQuestionnaire')
      this.closeModal()
    }
  },

  beforeDestroy () {
    this.$off('showModal')
    this.$off('widgetChanged')
  }
}
</script>

<style lang="scss" scoped>
  .widget {
    display: inline;
  }

  .widget-input {
    margin-bottom: 30px;
  }

  .widget-label {
    font-weight: bold;
  }

  .edit-modal {
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    max-width: 1700px;
    height: 50%;
    max-height: 700px;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;
    overflow: auto;

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .modalBody {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: calc(100% - 37px);
      overflow-y: auto;
    }
  }

  .button-box {
    margin-bottom: 30px;
    margin-right: 30px;
    .btn {
      margin-left: 10px;
    }
  }

  .input-subtext {
    color: #777;
  }

  @media only screen and (max-device-width : 680px) {
    .edit-modal {
      top: 0;
      left: 0;
      margin-left: 0;
      width: 100%;
      min-height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/questionnaires/widget-group/GroupEditModal.vue